export function searchPlaces(query, radius, location) {
  return new Promise((resolve, reject) => {
    // Ensure that the map object is available or create a dummy one
    const map = new google.maps.Map(document.createElement('div'));
    const service = new google.maps.places.PlacesService(map);
    const latlng = new google.maps.LatLng(location.latitude, location.longitude)

    service.textSearch({
      query: query,
      type: 'gas_station',
      locationRestriction: {
        circle: {
          center: latlng,
          radius: radius
        }
      }
    }, (results, status) => {
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        const places = results.map((result) => {
          return placeToJson(result)
        })
        resolve(places);
      } else {
        reject(new Error(`Place text search request failed. Status: ${status}`));
      }
    });
  });
}

export function fetchPlace(placeId) {
  return new Promise((resolve, reject) => {
    // Ensure that the map object is available or create a dummy one
    const map = new google.maps.Map(document.createElement('div'));
    const service = new google.maps.places.PlacesService(map);

    const request = {
      placeId: placeId,
      fields: ['name', 'address_components', 'adr_address',
        'business_status', 'formatted_address', 'icon', 'icon_mask_base_uri',
        'icon_background_color', 'photo', 'place_id', 'type', 'url', 'vicinity', 'website', 'formatted_phone_number',
        'current_opening_hours', 'opening_hours', 'rating', 'geometry']
    };

    service.getDetails(request, (place, status) => {
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        resolve(placeToJson(place));
      } else {
        reject(new Error(`Place details request failed. Status: ${status}`));
      }
    });
  });
}


function placeToJson(place) {
  // Helper function to handle LatLng objects
  const latLngToJson = (latLng) => latLng ? { lat: latLng.lat(), lng: latLng.lng() } : null;

  // Helper function to handle nested objects
  const objectToJson = (obj) => {
    if (!obj) return null;
    return Object.keys(obj).reduce((acc, key) => {
      acc[key] = convertToJson(obj[key]);
      return acc;
    }, {});
  };

  // Main conversion function
  const convertToJson = (value) => {
    if (value instanceof google.maps.LatLng) {
      return latLngToJson(value);
    } else if (value instanceof google.maps.LatLngBounds) {
      return {
        northeast: latLngToJson(value.getNorthEast()),
        southwest: latLngToJson(value.getSouthWest())
      };
    } else if (Array.isArray(value)) {
      return value.map(convertToJson);
    } else if (typeof value === 'object' && value !== null) {
      return objectToJson(value);
    }
    return value;
  };

  // Convert the entire place object
  return convertToJson(place);
}